import { useVideoCreatorStore } from '@src/stores-v2/VideoCreatorStoreContext';
import React from 'react';
import styled from 'styled-components';

import type { ElementState } from '../../renderer/ElementState';

interface VideoPresetProps {
  activeElement: ElementState;
  url: string;
}

export const VideoPreset: React.FC<VideoPresetProps> = props => {
  const videoCreator = useVideoCreatorStore();
  const getElement = () => {
    if (videoCreator.isOriginalVideoElement(props.activeElement.source)) {
      const video = videoCreator.currentVideo;
      return {
        id: video?.id,
        title: video?.title,
        thumbnail: video?.thumbnail?.url,
      };
    }
    const video = videoCreator.story?.storyArtifactsVideo?.find(
      p => p.url === props.url,
    );
    return {
      id: video?.id,
      title: video?.title,
      thumbnail: video?.video?.thumbnailUrl,
    };
  };

  // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
  const getThumbnail = () => {
    const element = getElement();
    return element?.thumbnail;
  };

  const videoElement = getElement();
  // need to replace click event with a modal that allows user to select a new video file
  return (
    <Main>
      {videoElement?.thumbnail ? (
        <Image src={videoElement.thumbnail} alt="image present" />
      ) : (
        <Video src={props.url} />
      )}
      <Description>{videoElement?.title}</Description>
    </Main>
  );
};

const Main = styled.div`
  position: relative;
  margin: 15px 0;
  border-radius: var(--radius-input);
  cursor: pointer;
  display: flex;
  gap: 10px;
  align-items: center;
`;

const Video = styled.video`
  width: 107px;
  height: 70px;
  border-radius: var(--radius);
`;

const Image = styled.img`
  width: 107px;
  height: 70px;
  border-radius: var(--radius);
  background-size: cover;
  object-fit: cover;
`;

const Description = styled.span`
  color: var(--text-secondary);
  font-weight: var(--font-weight-light);
  font-size: var(--text-xs);
  line-height: 12px;
`;
